

import React , { useEffect }  from 'react';
import app from "./app" 
import {GridWrap, ListWrap, Elements} from "./helpers" 


export const TimelineOne = function({data, index, widgetType, mode, device}) { 

    const domWindow = app.getDom();

    useEffect(() => {
        if(mode === "edit"){
            if (!domWindow) return;
            if(domWindow){
                detectTouchedCols();
            }
            // window.addEventListener('resize', detectTouchedCols);
            return () => window.removeEventListener('resize', detectTouchedCols);
        }
    },[JSON.stringify(data)]);

    useEffect(() => {
        if(mode === "live"){
            detectTouchedCols();
        }
    },[]);

    const detectTouchedCols = () => {
        const row = domWindow.querySelector(`.row.timeline.layout-${data.properties.layout}`);
        if (!row) return;
        const rowRect = row.getBoundingClientRect();
        const cols = row.querySelectorAll('.col');

        cols.forEach(col => col.classList.remove('touched'));
            cols.forEach(col => {
            const colRect = col.getBoundingClientRect();
            col.classList.remove('touched-bottom');
            col.classList.remove('touched-top');
            if (Math.abs(colRect.bottom - rowRect.bottom) <= 1) {
                col.classList.add('touched-bottom');
            }
            if(Math.abs(colRect.top - rowRect.top) <= 1){
                col.classList.add('touched-top');
            }
        });
    };

    let listitem = "" 
    if(data.elements.experienceList){ 
         if(data.elements.experienceList.items){   
            listitem = data.elements.experienceList.items.map(function(v, i){
                
                    return <GridWrap data={v} key={'key-' + v.viewId + i} id="experienceList" mode={mode} device={device}>
                        <div class={`timeline-item ${i%2 === 0?"":"odd"}`} style={{"color" : app.elementBackground(v.year.properties.background, v.year.properties.backgroundType, v.year.properties.overlayColor)}}>
                            <div className="timeline-date">
                                <Elements row={v.year} id={"year"} device={device} mode={mode} />  
                                <span className="dot" style={{"background" : app.elementBackground(v.year.properties.background, v.year.properties.backgroundType, v.year.properties.overlayColor), "color" : app.elementBackground(v.year.properties.background, v.year.properties.backgroundType, v.year.properties.overlayColor)}}></span>
                            </div>
                            <div class="timeline-content">
                                <Elements row={v.heading} id={"heading"} device={device} mode={mode} />  
                                <Elements row={v.subHeading} id={"subHeading"} device={device} mode={mode} />  
                                <Elements row={v.summary} id={"summary"} device={device} mode={mode} /> 
                            </div> 
                        </div> 
                    </GridWrap>  
            }) 
        }
        
        listitem = <ListWrap data={data.elements.experienceList} mode={mode} device={device} index={index} className={`timeline layout-${data.properties.layout}`}>
            {listitem}
        </ListWrap>
    }

    return <div className="container-fluid p-0 position-relative"> 
        <div className="row">
            <div className="col-12">
                <Elements row={data.elements.heading} id={"heading"} device={device} mode={mode} />
                <Elements row={data.elements.summary} id={"summary"} device={device} mode={mode} />  
            </div>
        </div>
        {listitem} 
    </div>
}


export const SkillsListOne = function({data, index, widgetType, mode, device}) { 
    let listitem = "" 
    if(data.elements.skillsList){ 
         if(data.elements.skillsList.items){   
            listitem = data.elements.skillsList.items.map(function(v, i){    
                return <GridWrap data={v} key={'key-' + v.viewId + i} id="skillsList" mode={mode} device={device}>
                    <Elements row={v.title} id={"title"} device={device} mode={mode} />  
                    <div className="d-inline-block w-100">
                        <div className="overflow-hidden p-1"> 
                            <Elements row={v.list} id={"list"} device={device} mode={mode} /> 
                        </div> 
                    </div> 
                </GridWrap>  
            }) 
        }
        
    listitem = <ListWrap data={data.elements.skillsList} mode={mode} device={device} index={index} mode={mode}>
        {listitem}
    </ListWrap>
    }

    return <div className="container-fluid p-0 position-relative"> 
        <div className="row">
            <div className="col-12">
                <Elements row={data.elements.heading} id={"heading"} device={device} mode={mode} />
                <Elements row={data.elements.summary} id={"summary"} device={device} mode={mode} />  
            </div>
        </div>
        {listitem} 
    </div>
}

export const ProfileOne = function({data, index, widgetType, mode, device}) { 
    return <div className="container-fluid p-0 position-relative"> 
        <div className="row">
            <div className="col-12 d-flex  justify-content-between align-items-center gap-4 flex-md-nowrap gap-1">
                <div className="flex-fill order-1 order-md-0">
                    { device !== "mobile" ? 
                        (
                            <>
                            <Elements row={data.elements.heading} id={"heading"} device={device} mode={mode} />
                            <Elements row={data.elements.subHeading} id={"subHeading"} device={device} mode={mode} />
                            </>
                        ) : 
                        (
                            <>
                            <div className="d-flex gap-3">
                                <div className={data.elements.banner.properties.show !== true ? 'd-none' : ''} style={{minWidth:"70px"}}>
                                    <Elements row={data.elements.banner} id={"banner"} device={device} mode={mode} />
                                </div>
                                <div className="item">
                                    <Elements row={data.elements.heading} id={"heading"} device={device} mode={mode} />
                                    <Elements row={data.elements.subHeading} id={"subHeading"} device={device} mode={mode} />
                                </div> 
                            </div>
                            </>
                        )
                    }
                    <Elements row={data.elements.summary} id={"summary"} device={device} mode={mode} />
                    <Elements row={data.elements.socialInfo} id={"socialInfo"} device={device} mode={mode} />
                </div>
                { device !== "mobile" ?  
                    (
                        <div className={data.elements.banner.properties.showWeb !== true ? 'd-none' : ''} style={{minWidth:"200px"}}>
                            <Elements row={data.elements.banner} id={"banner"} device={device} mode={mode} />
                        </div>
                    ) : (null)
                }
                {/* <img src="https://mediadirhub.com/avatar?name=Alex Carte&c=CCCCCC" width="200" alt="Avatar" /> */}
            </div>
        </div>
    </div>
}


export const TagsOne = function({data, index, widgetType, mode, device}) { 
    

    return <div className="container-fluid p-0 position-relative"> 
        <div className="row">
            <div className="col-12">
                <Elements row={data.elements.heading} id={"heading"} device={device} />
                <Elements row={data.elements.summary} id={"summary"} device={device} />
                <Elements row={data.elements.list} id={"list"} device={device} />
            </div>
        </div>
       
    </div>
}




 